<template>
  <span class="ps-text-container">
    <span v-for="(item, index) in parseText" :key="index">
      <span :style="{ 'font-size': isKatexFontSize() }" v-katex="item.value" v-if="item.katex"></span>
      <span v-html="item.value" v-else></span>
    </span>
  </span>
</template>
<script>
/**
 * @namespace PsText
 * @author Paweł Sala
 */
// import TrText from "../components/TrText";
/**
 * @vue-prop  {String} textValue any text you want katex or html tags to handle
 * @vue-prop  {String} fontSize
 */

import _ from 'lodash';
export default {
  name: 'ps-text',
  components: {},
  props: {
    textValue: {
      type: String,
      default: function () {
        return {};
      },
    },
    fontSize: {
      type: [String, Number],
      required: false,
      default: function () {
        return '100%';
      },
    },
  },

  methods: {
    isKatexFontSize() {
      if (typeof this.fontSize === 'number') {
        return '100%';
      }
      if (this.fontSize) {
        return this.fontSize;
      } else {
        return '100%';
      }
    },
    /** Function added only for compatibility with hack in textBlock type components */
    removeUnnecessarySlash(string) {
      const search = '\\\\';
      const replaceWith = '\\';
      const result = string.split(search).join(replaceWith);
      return result;
      // return _.replace(string, '\\\\', '\\');
    },
    parseKatex(string) {
      let parsed = [];
      let split = string.split(/(_#.*?#_)/g);
      if (split) {
        // for (const item of split) {
        parsed = split.map((item) => {
          let katexFlag = false;
          let match = item.match(/_#(.*?)#_/g);
          if (match) {
            katexFlag = true;
            item = item.substring(2, item.length - 2);
            item = this.removeUnnecessarySlash(item);
          }
          return { katex: katexFlag, value: item };
        });
        // }
      }
      return parsed;
    },
  },
  computed: {
    parseText() {
      return this.parseKatex(this.textValue);
    },
  },
};
</script>
<style lang="scss" scoped></style>
